import { useHistory } from 'react-router-dom';
import querystring from 'querystring';

// sometimes some parameters like page number should be tracked
// in order to preserve the state when refreshing the page
// url query is the most common way to track these parameters
// since react does not parse the search query from url, useUrlQuery will do the job
const useUrlQuery = () => {
  const history = useHistory();
  const { location } = history;

  // gets the url query in object form
  const getQuery = () => querystring.parse(location.search.replace(/^\?/, ''));

  // sets the url query
  // if url has an existing query, it will replace the location, otherwise it pushes
  const setQuery = (newQuery: {[key: string]: any}) => {
    const shouldPush = !Object.keys(getQuery()).length;
    const search = `?${querystring.stringify(newQuery)}`;
    if (shouldPush) history.push({ search });
    else history.replace({ search });
  };

  // the query object to be provided
  const query = getQuery();

  return {
    query,
    getQuery,
    setQuery
  };
};

export default useUrlQuery;
